import React from "react";
import { Redirect, Route } from "react-router-dom";
import { IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";

import LoginPage from "../pages/Login/login";
import UserRegistration from "../pages/UserRegistration/UserRegistration";
import AppLayout from "./AppLayout/AppLayout";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import ResetPasswordPage from "../pages/ResetPassword/ResetPassword";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";


const Router: React.FC = () => (
  <IonReactRouter>
    <IonRouterOutlet>
      <Route path="/user-activate" component={UserRegistration} />
      <Route path="/login" component={LoginPage} exact={true} />
      <Route exact path="/" render={() => <Redirect to="/login" />} />
      <Route path="/client" render={() => <AppLayout />} />
      <Route path="/forgot-password" component={ForgotPassword} exact={true} />
      <Route path="/reset-password" component={ResetPasswordPage} />
     <Route path="/privacy-policy/ps" component={PrivacyPolicy} exact />
    </IonRouterOutlet>
  </IonReactRouter>
);

export default Router;
